// Mapa ebookId → imagem usado no Checkout. Mantido separado de `products.js`
// porque o último item ('cifras-musicas-extras') aponta para `/capaEbooksLoja/musicasextras.png`
// aqui, enquanto o catálogo (`products.js`) usa `/capaEbooksLoja/image.png`. Se a divergência
// for um bug, troque por `findProductById(id).image` em Checkout.js.
export const PRODUCTS_IMAGES = {
  'colecao-completa-13-1': '/capaEbooksLoja/colecaocompleta.png',
  tablaturas: '/capaEbooksLoja/fingerstyle.png',
  'cifras-advento': '/capaEbooksLoja/musicasAdvento.png',
  'cifras-natal': '/capaEbooksLoja/musicasnatal.png',
  'cifras-quaresma': '/capaEbooksLoja/musicasquaresma.png',
  'cifras-pascoal': '/capaEbooksLoja/musicaspascoa.png',
  'cifras-tempo-comum': '/capaEbooksLoja/tempocomum.png',
  'cifras-partes-fixas': '/capaEbooksLoja/musicaspartesfixas.png',
  'cifras-adoracao': '/capaEbooksLoja/adoracao.png',
  'cifras-marianas': '/capaEbooksLoja/marianas.png',
  'cifras-grupos-oracao': '/capaEbooksLoja/gruposdeoracao.png',
  'cifras-infantis': '/capaEbooksLoja/musicasinfantis.png',
  'cifras-mais-conhecidas': '/capaEbooksLoja/maisconhecidas.png',
  'cifras-que-nos-marcaram': '/capaEbooksLoja/musicasmarcantes.png',
  'cifras-musicas-extras': '/capaEbooksLoja/musicasextras.png',
  'curso-fingerstyle-catolico': '/capaEbooksLoja/capaCurso.png',
};
